import * as React from 'react';

// #region Component Props

interface IProps {
    label       : string;
    value       : any;
    className?  : string;
    placeholder?: string;
}

// #endregion

const ReadView = (props : IProps) => {

    const { 
        label, 
        value, 
        className, 
        placeholder
    } = props;

    return <div className={`linear-data-display ${ className }`}>
                <p>{ label }</p>
                <div/>
                <p>{ value !== undefined ? value : placeholder }</p>
            </div>;
};

ReadView.defaultProps = {
    className   : '',
    placeholder : ''
};

export { ReadView };
